// jshint esversion: 6
/**
 * Selectors
 */
const $headerFixed = $('.site-header');

/**
 * Methods
 */
function fixedHeaderResize () {
	let scroll = getCurrentScroll();
	if ( scroll >= $headerFixed.innerHeight()/2 ) {
		$headerFixed.addClass('is-opaque');
	} else {
		$headerFixed.removeClass('is-opaque');
	}
}

/**
 * Events/init
 */
if ( $headerFixed.length ) {
	window.addEventListener( 'scroll', fixedHeaderResize, false );
}

function getCurrentScroll () {
	return window.pageYOffset || document.documentElement.scrollTop;
}
